<template>
	<main class="page">
		<slot />
	</main>
</template>

<script>
export default {
	name: 'Page'
}
</script>

<style lang="scss" scoped>
.page {
	position: absolute;
	width: 100%;
	height: 100%;
	overflow-y: auto;
	background-color: white;
	-webkit-overflow-scrolling: touch;
}
</style>
